import { type RefObject, useEffect, useRef } from 'react'

export function useMousePositionRef(
	containerRef?: RefObject<HTMLElement | SVGElement | null>,
) {
	const positionRef = useRef({ x: 0, y: 0 })

	useEffect(() => {
		const updatePosition = (x: number, y: number) => {
			if (containerRef?.current) {
				const rect = containerRef.current.getBoundingClientRect()
				// Calculate position relative to center of container
				const centerX = rect.width / 2
				const centerY = rect.height / 2
				const relativeX = x - rect.left - centerX
				const relativeY = y - rect.top - centerY
				positionRef.current = { x: relativeX, y: relativeY }
			} else {
				// Calculate position relative to center of viewport
				const centerX = window.innerWidth / 2
				const centerY = window.innerHeight / 2
				positionRef.current = { x: x - centerX, y: y - centerY }
			}
		}

		const handleMouseMove = (ev: MouseEvent) => {
			updatePosition(ev.clientX, ev.clientY)
		}

		const handleTouchMove = (ev: TouchEvent) => {
			const touch = ev.touches[0]
			if (touch) {
				updatePosition(touch.clientX, touch.clientY)
			}
		}

		window.addEventListener('mousemove', handleMouseMove)
		window.addEventListener('touchmove', handleTouchMove)

		return () => {
			window.removeEventListener('mousemove', handleMouseMove)
			window.removeEventListener('touchmove', handleTouchMove)
		}
	}, [containerRef])

	return positionRef
}
